// package: featurerequest
// file: feature-request.proto

var feature_request_pb = require("./feature-request_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var FeatureRequest = (function () {
  function FeatureRequest() {}
  FeatureRequest.serviceName = "featurerequest.FeatureRequest";
  return FeatureRequest;
}());

FeatureRequest.CreatePost = {
  methodName: "CreatePost",
  service: FeatureRequest,
  requestStream: false,
  responseStream: false,
  requestType: feature_request_pb.CreatePostReq,
  responseType: feature_request_pb.CreatePostReply
};

FeatureRequest.ListPosts = {
  methodName: "ListPosts",
  service: FeatureRequest,
  requestStream: false,
  responseStream: false,
  requestType: feature_request_pb.ListPostsReq,
  responseType: feature_request_pb.ListPostsReply
};

FeatureRequest.GetPost = {
  methodName: "GetPost",
  service: FeatureRequest,
  requestStream: false,
  responseStream: false,
  requestType: feature_request_pb.GetPostReq,
  responseType: feature_request_pb.GetPostReply
};

FeatureRequest.Vote = {
  methodName: "Vote",
  service: FeatureRequest,
  requestStream: false,
  responseStream: false,
  requestType: feature_request_pb.VoteReq,
  responseType: feature_request_pb.VoteReply
};

FeatureRequest.RemoveVote = {
  methodName: "RemoveVote",
  service: FeatureRequest,
  requestStream: false,
  responseStream: false,
  requestType: feature_request_pb.RemoveVoteReq,
  responseType: feature_request_pb.RemoveVoteReply
};

FeatureRequest.AddComment = {
  methodName: "AddComment",
  service: FeatureRequest,
  requestStream: false,
  responseStream: false,
  requestType: feature_request_pb.AddCommentReq,
  responseType: feature_request_pb.AddCommentReply
};

FeatureRequest.ListComments = {
  methodName: "ListComments",
  service: FeatureRequest,
  requestStream: false,
  responseStream: false,
  requestType: feature_request_pb.ListCommentsReq,
  responseType: feature_request_pb.ListCommentsReply
};

FeatureRequest.DeleteComment = {
  methodName: "DeleteComment",
  service: FeatureRequest,
  requestStream: false,
  responseStream: false,
  requestType: feature_request_pb.DeleteCommentReq,
  responseType: feature_request_pb.DeleteCommentReply
};

FeatureRequest.AdminUpdatePostStatus = {
  methodName: "AdminUpdatePostStatus",
  service: FeatureRequest,
  requestStream: false,
  responseStream: false,
  requestType: feature_request_pb.AdminUpdatePostStatusReq,
  responseType: feature_request_pb.AdminUpdatePostStatusReply
};

FeatureRequest.AdminRespondToPost = {
  methodName: "AdminRespondToPost",
  service: FeatureRequest,
  requestStream: false,
  responseStream: false,
  requestType: feature_request_pb.AdminRespondToPostReq,
  responseType: feature_request_pb.AdminRespondToPostReply
};

FeatureRequest.AdminDeletePost = {
  methodName: "AdminDeletePost",
  service: FeatureRequest,
  requestStream: false,
  responseStream: false,
  requestType: feature_request_pb.AdminDeletePostReq,
  responseType: feature_request_pb.AdminDeletePostReply
};

FeatureRequest.AdminListPosts = {
  methodName: "AdminListPosts",
  service: FeatureRequest,
  requestStream: false,
  responseStream: false,
  requestType: feature_request_pb.AdminListPostsReq,
  responseType: feature_request_pb.AdminListPostsReply
};

exports.FeatureRequest = FeatureRequest;

function FeatureRequestClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

FeatureRequestClient.prototype.createPost = function createPost(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(FeatureRequest.CreatePost, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

FeatureRequestClient.prototype.listPosts = function listPosts(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(FeatureRequest.ListPosts, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

FeatureRequestClient.prototype.getPost = function getPost(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(FeatureRequest.GetPost, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

FeatureRequestClient.prototype.vote = function vote(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(FeatureRequest.Vote, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

FeatureRequestClient.prototype.removeVote = function removeVote(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(FeatureRequest.RemoveVote, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

FeatureRequestClient.prototype.addComment = function addComment(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(FeatureRequest.AddComment, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

FeatureRequestClient.prototype.listComments = function listComments(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(FeatureRequest.ListComments, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

FeatureRequestClient.prototype.deleteComment = function deleteComment(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(FeatureRequest.DeleteComment, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

FeatureRequestClient.prototype.adminUpdatePostStatus = function adminUpdatePostStatus(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(FeatureRequest.AdminUpdatePostStatus, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

FeatureRequestClient.prototype.adminRespondToPost = function adminRespondToPost(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(FeatureRequest.AdminRespondToPost, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

FeatureRequestClient.prototype.adminDeletePost = function adminDeletePost(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(FeatureRequest.AdminDeletePost, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

FeatureRequestClient.prototype.adminListPosts = function adminListPosts(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(FeatureRequest.AdminListPosts, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.FeatureRequestClient = FeatureRequestClient;

